import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getReporteVentasCortesias } from '../../../../service/reportes/VentasCortesias';

export interface DetalleVenta {
  folio_ticket: string;
  evento: string;
  venta_id: number;
  fecha_hora_venta: string;
  producto: string;
  cantidad: number;
  precio_unitario: number;
  total_venta: number;
  forma_pago: string;
  punto_venta_id: number;
  punto_venta: string;
  tipo_punto_venta: string;
}

export interface ResumenTicket {
  folio_ticket: string;
  evento: string;
  saldo_actual: number;
  activo: number;
  folio_nuevo: string | null;
  cliente: string;
  total_cortesia: number;
  saldo_recarga_caja: number;
  total_consumido_puesto: number;
  transferido: number;
  balance: number;
  diferencia_saldo: number;
  fecha_primera_cortesia: string;
}

export interface TicketConCortesia {
  folio: string;
  resumen: ResumenTicket;
  detalle: DetalleVenta[];
}

export const useReporteVentasCortesias = (reload: number) => {
  const [list, setList] = useState<TicketConCortesia[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      setLoadingRequest(true);
      try {
        const data = await getReporteVentasCortesias([]);
        setList(data ?? []);
      } catch (error) {
        history.push('/error/500');
      } finally {
        setLoadingRequest(false);
      }
    };
    fetchData();
  }, [reload]);

  return { list, loadingRequest };
};
